import { Controller, Toolbar, Menu } from '@tencent/workbench';
import { ItalicFeature } from './italic-feature';
import { TOOLBAR_ITEMS, config, MENU_CONFIGS } from './config';
import { Form } from '@tencent/wb-ext-form';
import { FORM_CONFIGS_ITALIC } from '@framework/workbench/drawer/ui/text/font/config';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
    formItems: FORM_CONFIGS_ITALIC,
})
export class ItalicController {
    constructor(private readonly feature: ItalicFeature) {
    }

    @Toolbar(config.id, 'onClick')
    @Menu(config.id, 'onClick')
    @Form(config.id, 'onClick')
    public onClick() {
        this.feature.callback(!this.feature.getItemValue());
    }

    @Toolbar(config.id, 'shouldCheck')
    @Menu(config.id, 'shouldCheck')
    @Form(config.id, 'value')
    public isChecked() {
        return this.feature.getItemValue();
    }

    @Form(config.id, 'onClick')
    public onDrawerClick() {
        this.feature.drawerCallback(!this.feature.getItemValue());
    }
}
